import { useQuery } from '@tanstack/react-query';

import { getBusinessTaxes } from 'api/admin/businesses/businesses';

const useTaxes = (businessId) => {
  const {
    isLoading,
    error,
    data = [],
  } = useQuery({
    queryKey: ['getBusinessTaxes', businessId],
    queryFn: async ({ queryKey }) => {
      const [, businessId] = queryKey;
      if (businessId) {
        const response = await getBusinessTaxes(businessId);
        const taxes = response.data.taxes;
        taxes.sort((a, b) => a.name.toLowerCase() - b.name.toLowerCase());

        const mappedTaxes = taxes.map((tax) => {
          return {
            value: tax.id,
            display: `${tax.name} (${tax.rate}%)`,
          };
        });
        return mappedTaxes;
      } else {
        return [];
      }
    },
    retry: 1,
  });

  return {
    isLoading,
    error: error?.response?.data?.error ?? error?.message ?? null,
    data,
  };
};

export default useTaxes;
